"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CATALOGUES_ROOT = void 0;
const CATALOGUES_ROOT = exports.CATALOGUES_ROOT = 'catalogues-root';
